import { useState, useEffect } from 'react'
import { useParams, useNavigate, useLocation } from "react-router-dom"
import { Link } from "react-router-dom";
// services
import * as webBridgeService from '../../../services/webBridgeService'
// styles
import styles from "./LeadCaptureList.module.css"
// components
import LCEvent from "../../../components/LeadCapture/LeadCaptureList/LCEvent"
import LoadingSpinner from "../../../components/Miscellaneous/LoadingSpinner"
const LeadCaptureList = () => {
    const navigate = useNavigate()
    const [leadCaptures, setLeadCaptures] = useState([])
    const [loaded, setLoaded] = useState(false);
    const createRequestBody = async () => {

        let requestBody = {}
        // if admin, show the checkboxes
        requestBody =
        {
            "futureOnly": true,//`${formData.futureOnly}`,
            "includeTests": false,//`${formData.includeTests}`
        }

        return await requestBody;
    }
    const fetchData = async () => {
        if (loaded === false) {
            const getReqBody = await createRequestBody()
            try {
                const LCEvents = await webBridgeService.fetchEvents(getReqBody)
                if (LCEvents && LCEvents.length > 0) {
                    setLeadCaptures(LCEvents)
                }
                else {
                    setLeadCaptures([])
                }
            } catch (err) {
                setLeadCaptures([])
            }

            setLoaded(true)
        }

    }
    useEffect(() => {

        fetchData()
    }, [])

    return (
        <div className="page-area">
            <h1>Lead Capture</h1><br /><br />
            <h4>Welcome to SmithBucklin Lead Capture Services.</h4>
            {loaded ?
                <>
                    <div className={styles.containerEvents}>
                        {leadCaptures && leadCaptures.length ?
                            leadCaptures.map((item, index) => (
                                <LCEvent
                                    eventItem={item}
                                    key={index}
                                ></LCEvent>
                            ))
                            :
                            <div>
                                <div className={styles.errorEventsMessage}> No lead capture events configured!</div>
                            </div>
                        }
                    </div>
                   
                </>
                :
                <LoadingSpinner />
            }
            <br /><br /><br /><br />
            <Link to="/LeadCaptureSelect" class={styles.navbarItems}>
                Lead Capture Select
            </Link>
        </div>
    );
}
export default LeadCaptureList;